import React, { useState, useEffect } from 'react';

const PropertyLocationMap = ({
  location,
  height = 220,
  title = "Property location",
  fill = false,
  showHeader = true
}) => {
  const [embedUrl, setEmbedUrl] = useState(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const query = (location || "").trim();
    if (query.length < 2) {
      setEmbedUrl(null);
      return undefined;
    }
    let cancelled = false;
    const timer = setTimeout(async () => {
      setLoading(true);
      try {
        const res = await fetch(
          `https://nominatim.openstreetmap.org/search?format=json&q=${encodeURIComponent(query)}&limit=1&accept-language=en`,
          { headers: { Accept: "application/json", "Accept-Language": "en" } }
        );
        const data = await res.json();
        if (cancelled || !data?.[0]) {
          if (!cancelled) setEmbedUrl(null);
          return;
        }
        const lat = parseFloat(data[0].lat);
        const lon = parseFloat(data[0].lon);
        const padLat = 0.018;
        const padLon = fill ? 0.032 : 0.024;
        const bbox = `${lon - padLon},${lat - padLat},${lon + padLon},${lat + padLat}`;
        setEmbedUrl(
          `https://www.openstreetmap.org/export/embed.html?bbox=${encodeURIComponent(bbox)}&layer=mapnik&marker=${lat}%2C${lon}`
        );
      } catch {
        if (!cancelled) setEmbedUrl(null);
      } finally {
        if (!cancelled) setLoading(false);
      }
    }, 500);
    return () => {
      cancelled = true;
      clearTimeout(timer);
    };
  }, [location, fill]);

  if (!(location || "").trim()) return null;

  const bodyStyle = fill ? undefined : { minHeight: height };

  return (
    <div className={`property-location-map${fill ? " property-location-map--fill" : ""}`}>
      {showHeader && (
        <div className="property-location-map-header">
          <i className="fas fa-map-marked-alt" style={{ color: "var(--primary)" }}></i>
          {title}
        </div>
      )}
      <div className="property-location-map-body" style={bodyStyle}>
        {loading && (
          <div className="property-location-map-placeholder">
            <i className="fas fa-spinner fa-spin"></i> Loading map…
          </div>
        )}
        {!loading && embedUrl && (
          <iframe
            key={embedUrl}
            className="property-location-map-frame"
            title={title}
            src={embedUrl}
            height={fill ? undefined : height}
            loading="lazy"
            referrerPolicy="no-referrer-when-downgrade"
            scrolling="no"
          />
        )}
        {!loading && !embedUrl && (
          <div className="property-location-map-placeholder">
            We could not plot this address yet. Try "City, State" or a full street address.
          </div>
        )}
      </div>
    </div>
  );
};

export default PropertyLocationMap;
